import { useState } from 'react'
import { Button } from '../common/button'
import { Link, NavLink } from 'react-router-dom'

const navigation = [
  { name: 'Home', href: '/' },
  { name: 'Product', href: '/products' },
  { name: 'About Us', href: '/about' },
  { name: 'Contact Us', href: '/contact' },
]

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <header id="header-section" className="relative z-50">
      <nav aria-label="Global" className="mx-auto flex max-w-7xl items-center justify-between p-6">
        {/* Logo */}
        <div className="flex">
          <Link to="/" className="">
            <span className="sr-only">Your Company</span>
            <img alt="" src="/logo.svg" className="h-[67px]" />
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <div className="flex lg:hidden">
          <button
            type="button"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="-m-2.5 inline-flex items-center justify-center rounded-md px-4 py-2.5 text-white bg-[#0e2048]"
          >
            {mobileMenuOpen ? '✕' : '☰'}
          </button>
        </div>

        {/* Desktop Nav Links */}
        <div className="hidden lg:flex lg:gap-6 xl:gap-x-10 bg-gradient-to-b from-[rgba(255,255,255,0.1)] to-[rgba(255,255,255,0)] px-10">
          {navigation.map((item) => (
            <NavLink
              key={item.name}
              to={item.href}
              className={({ isActive }) =>
                `font-oxanium text-sm py-4 uppercase border-t-0 border-x-0 ${
                  isActive
                    ? 'text-[#4BBACE] border border-b-[#4BBACE]'
                    : 'text-white border border-transparent'
                }`
              }
            >
              {item.name}
            </NavLink>
          ))}
        </div>

        {/* Desktop Right Section */}
        <div className="hidden lg:flex lg:justify-end">
          <div className="flex items-center gap-3">
            <Link
              to="/login"
              className="text-sm py-3 px-8 rounded-full font-oxanium uppercase bg-[linear-gradient(90deg,_rgba(8,215,185,1)_0%,_rgba(16,170,240,1)_33%,_rgba(98,65,246,1)_66%,_rgba(169,2,255,1)_100%)] text-white"
            >
              Login
            </Link>
            <Button classes="text-sm py-3 px-8 rounded-full" text="Schedule a call" />
            <img src="https://i.pravatar.cc" alt="" className="h-10 w-10 rounded-full object-cover" />
          </div>
        </div>
      </nav>

      {/* Mobile Dropdown Overlay */}
      <div
        className={`absolute top-full left-0 w-full bg-[#0e2048] px-6 pt-8 pb-16 transition-all duration-300 ease-in-out ${
          mobileMenuOpen ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4 pointer-events-none'
        }`}
      >
        {navigation.map((item, idx) => (
          <NavLink
            key={item.name}
            to={item.href}
            onClick={() => setMobileMenuOpen(false)}
            className={({ isActive }) =>
              `block uppercase font-oxanium text-base py-3 ${
                idx === navigation.length - 1 ? 'mb-10' : 'mb-0'
              } transition-colors duration-200 border-t-0 border-x-0 border-b border-gray-200/20 ${
                isActive
                  ? 'text-[#4BBACE] border border-b-[#4BBACE]'
                  : 'text-white border border-transparent'
              }`
            }
          >
            {item.name}
          </NavLink>
        ))}

        <Link
          to="/login"
          onClick={() => setMobileMenuOpen(false)}
          className="inline-block text-sm py-3 px-8 rounded-full font-oxanium uppercase bg-[linear-gradient(90deg,_rgba(8,215,185,1)_0%,_rgba(16,170,240,1)_33%,_rgba(98,65,246,1)_66%,_rgba(169,2,255,1)_100%)] text-white"
        >
          Login
        </Link>
      </div>
    </header>
  )
}
